import React from 'react';
import Select, { StylesConfig, Props as SelectProps, OptionTypeBase } from 'react-select';
import { Box } from '../../wag-react/next-components/box';
import { HelperText, HelperTextProps } from './HelperText';

// Export the styles to allow consumer to do styles composition
export const styles: StylesConfig<OptionTypeBase, boolean> = {
  control: (provided, state) => ({
    ...provided,
    padding: '8px',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: state.selectProps.error && 'red' || (state.selectProps.variant === 'filled' ? '#EDEDED' : '#D1D1D1'),
    backgroundColor: state.selectProps.variant === 'filled' ? '#EDEDED' : 'white'
  }),
  placeholder: provided => ({
    ...provided,
    color: '#AAAAAA',
    fontFamily: 'muli'
  }),
  singleValue: provided => ({
    ...provided,
    color: '#727272',
    fontFamily: 'muli'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '2px'
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0
  }),
  input: provided => ({
    ...provided,
    padding: 0,
    margin: 0
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: '24px'
  })
};
type Variant = 'outlined' | 'filled';
export type DropdownProps = SelectProps & {
  error?: boolean;
  helperText?: string;
  helperTextProps?: HelperTextProps;
  label?: string;
  name?: string;
  variant?: Variant;
};
export const Dropdown = ({
  name,
  label,
  helperText,
  helperTextProps,
  ...rest
}: DropdownProps) => <Box data-sentry-element="Box" data-sentry-component="Dropdown" data-sentry-source-file="index.tsx">
    <Select id={name} inputId={name} styles={styles} placeholder={label} isSearchable={false} {...rest} data-sentry-element="Select" data-sentry-source-file="index.tsx" />
    {helperText && <HelperText text={helperText} error={rest.error} {...helperTextProps} />}
  </Box>;